<template>
  <div class="bg-white">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto">
        <p class="font-bold text-lg mb-6">Info Partner</p>
        <div class="mb-6 max-w-sm">
          <TextField type="text" label="ID" :disabled="true" v-model="id" />
        </div>
        <div class="mb-6 ">
          <TextField type="text" label="Nama" v-model="payloads.name" placeholder="Nama partner" />
        </div>
        <div class="mb-6">
          <TextField type="text" label="No. Handphone" v-model="payloads.phone_number" placeholder="No Handphone" />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Alamat Email" v-model="payloads.email" placeholder="Alamat Email" />
        </div>
        <div class="mb-6">
          <Textarea label="Alamat" v-model="payloads.address" placeholder="Alamat" />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kota / Wilayah</label>
          <CustomSelect :options="cities" v-model="selectedCity" :default="selectedCity" optionLabel="name" />
        </div>
      </div>
      <div class="flex-1 mdmax:w-full mdmax:flex-auto">
        <div class="p-6 ">
          <p class="font-bold text-lg mb-6">No. Rekening</p>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Bank</label>
            <CustomSelect :options="bankCodes" v-model="selectedBank" :default="selectedBank" placeholder="Pilih nama bank" optionLabel="name" />
          </div>
          <div class="mb-12">
            <TextField type="text" label="No. Rekening" v-model="payloads.bank_account" placeholder="Masukan nomor rekening" />
          </div>
          <div class="">
            <FileBrowser
              id="stnk"
              accept=".jpg, .png, .jpeg"
              label="Upload Dokumen"
              button="Browse"
              placeholder="Pilih file yang akan di upload"
              @change="handleFileSelect($event, 'stnk', 'idcard_file_url')"
            />
            <div class="w-40 mt-4" v-if="payloads.idcard_file_url">
              <img :src="payloads.idcard_file_url" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end">
      <Button buttonText="Simpan" @action="submit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Textarea: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Textarea'),
    FileBrowser: () => import(/* webpackChunkName: "form" */ '@/components/Forms/FileBrowser'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button')
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      payloads: {
        email: null,
        phone_number: null,
        name: null,
        address: null,
        area_code: null,
        bank_code: null,
        bank_account: null,
        idcard_file_url: null,
        is_published: true
      },
      id: null,
      selectedCity: null,
      selectedBank: null
    }
  },
  computed: {
    ...mapGetters('master', ['bankCodes']),
    ...mapGetters('master', ['cities']),
    ...mapGetters('partner', ['partnerDetail']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('armada', ['partnerArmadaDetail']),
    partnerId() {
      return this.userData?.user?.group_id
    }
  },
  mounted() {
    if (this.mode === 'edit') {
      this.getPartnerInformartion()
      this.getCityList()
    } else {
      this.getBankCodeList()
      this.getCityList()
    }
  },
  methods: {
    ...mapActions('master', ['getBankCodes', 'getCities']),
    ...mapActions('armada', ['createPartnerArmada', 'getPartnerArmadaDetail']),
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading', 'uploadImage']),
    getCityList() {
      this.getCities({
        params: {
          page: 1,
          per_page: 1000,
          search_keyword: ''
        }
      })
    },
    getPartnerInformartion() {
      this.visibleContent = false
      this.showLoading()
      this.getPartnerArmadaDetail({
        partnerId: this.partnerId,
        vehiclePartnerId: this.$route.params.id
      }).then(res => {
        const response = res.data.data
        this.getBankCodeList(response)
        this.visibleContent = true
      })
    },
    getBankCodeList(partnerInfo = null) {
      this.getBankCodes().then(res => {
        const bankList = res.data.data
        const areaCode = this.cities.filter(item => {
          return item.code === partnerInfo.area_code
        })[0]
        if (partnerInfo) {
          this.id = partnerInfo.id
          this.payloads = {
            area_code: partnerInfo.area_code,
            bank_code: partnerInfo.bank_code,
            bank_account: partnerInfo.bank_account,
            idcard_file_url: partnerInfo.idcard_file_url,
            is_published: partnerInfo.is_published,
            id: partnerInfo.id,
            name: partnerInfo.name,
            phone_number: partnerInfo.phone_number,
            email: partnerInfo.email,
            address: partnerInfo.address
          }
          this.selectedCity = areaCode
          this.selectedBank = bankList.filter(item => item.code === partnerInfo.bank_code)[0]
          this.hideLoading()
        }
      })
    },
    handleFileSelect(file, purpose, target) {
      this.showLoading()
      let imageData = new FormData()
      imageData.append('image', file)
      imageData.append('file_purpose', purpose)
      this.uploadImage({ payloads: imageData }).then(res => {
        this.hideLoading()
        this.payloads[target] = res.file_url
      })
    },
    submit() {
      this.showLoading()
      const payloads = {
        email: this.payloads.email,
        phone_number: this.payloads.phone_number,
        name: this.payloads.name,
        address: this.payloads.address,
        area_code: this.selectedCity.code,
        bank_code: this.selectedBank.code,
        bank_account: this.payloads.bank_account,
        idcard_file_url: this.payloads.idcard_file_url,
        is_published: true
      }
      this.createPartnerArmada({
        partnerId: this.partnerId,
        payloads: payloads
      }).then(res => {
        this.resetData()
        console.log(res)
        this.hideLoading()
        this.setToast({
          options: { type: 'success', duration: 5000, primaryText: 'Penambahan Armada Berhasil', secondaryText: 'Data telah kami simpan, silahkan tutup halaman ini' }
        })
      })
    },
    resetData() {
      this.payloads = {
        email: null,
        phone_number: null,
        name: null,
        address: null,
        area_code: null,
        bank_code: null,
        bank_account: null,
        idcard_file_url: null,
        is_published: true
      }
      this.id = null
      this.selectedCity = null
      this.selectedBank = null
    }
  }
}
</script>
